<button
  class="text-white bg-gradient-to-r hover:bg-gradient-to-br text-xs add-btn"
  color="primary"
  routerLinkActive="router-link-active"
  [ngClass]="{
    'ddc-gradient-light': _isLightTheme,
    'ddc-gradient-dark': _isDarkTheme,
    'ddc-gradient-paper': _isPaperTheme,
    'ddc-btn-small': _size === 'small',
  }"
  [routerLink]="[_dynamicRoute]"
>
  {{ _label }}
</button>
